// GENERATED by tools/migration/gen-route-manifest.mjs from docs/migration/routes.json - do not edit by hand.
// Every page of the Angular app: its URL, the Angular component it renders, and the params it reads.

export interface ManifestPage {
  url: string;
  /** Angular component class name (used for the "not migrated yet" placeholder and the parity checklist). */
  component: string;
  /** Matrix params (";id=...") the Angular screen reads. A page with any is mounted through MatrixSwitch. */
  matrix: readonly string[];
  query: readonly string[];
}

export const manifestPages: readonly ManifestPage[] = [
  {
    url: '/home/dashboard',
    component: 'DashboardComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/accountclient',
    component: 'AccountsClientComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/manage/clients',
    component: 'ClientListComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/manage/addClient',
    component: 'AddClientComponent',
    matrix: ['id'],
    query: [],
  },
  {
    url: '/home/manage/users',
    component: 'UsersListComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/manage/addUser',
    component: 'AddUserComponent',
    matrix: ['id'],
    query: [],
  },
  {
    url: '/home/settings/authorisation-codes',
    component: 'AuthoriseCodeComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/settings/reports-formate',
    component: 'ReportformatComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/settings/accountants',
    component: 'AccountantsComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/settings/addaccountants',
    component: 'AddNewAccountantsComponent',
    matrix: ['id'],
    query: [],
  },
  {
    url: '/home/settings/limited-company',
    component: 'LimitedcompanyComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/settings/limited-company-FRS102',
    component: 'LimitedcompanyFRS102Component',
    matrix: [],
    query: [],
  },
  {
    url: '/home/settings/limited-company-FRS105',
    component: 'LimitedcompanyFRS105Component',
    matrix: [],
    query: [],
  },
  {
    url: '/home/settings/llp',
    component: 'LlpComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/settings/partnership',
    component: 'PartnershipComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/settings/sole-trader',
    component: 'SoletraderComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/settings/email-templates',
    component: 'EmialtemplatesComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/settings/chart-accounts',
    component: 'ChartofaccountsComponent',
    matrix: ['type'],
    query: [],
  },
  {
    url: '/home/settings/logo-report',
    component: 'LogoonreportComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/settings/data-security',
    component: 'DataSecurityComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/settings/update-directors',
    component: 'UpdateDirectorsComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/settings/addnewaccount',
    component: 'AddNewAccountComponent',
    matrix: ['type', 'id'],
    query: [],
  },
  {
    url: '/home/taxreturns/dashboard',
    component: 'TaxreturnDashboardComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/taxreturns/tasks-trialbalance',
    component: 'TaxreturnTasksComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/taxreturns/tasks-submit',
    component: 'TaxreturnTaskSubmitComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/taxreturns/tasks-createtrialbalance',
    component: 'TaxreturnTaskCreatetrialbalanceComponent',
    matrix: ['id'],
    query: [],
  },
  {
    url: '/home/taxreturns/settings-datasecurity',
    component: 'TaxreturnDatasecurityComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/taxreturns/settings-accoununts',
    component: 'TaxreturnChartofaccountsComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/taxreturns/settings-reportsettings',
    component: 'TaxreturnReportsettingsComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/taxreturns/company-contact',
    component: 'CompanyContactComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/taxreturns/report-setting',
    component: 'ReportSettingComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/taxreturns/share-capital',
    component: 'ShareCapitalComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/taxreturns/director-report',
    component: 'DirectorReportComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/taxreturns/accountant-report',
    component: 'AccountantReportComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/taxreturns/accounting-policy',
    component: 'AccountingPolicyComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/taxreturns/additional-notes',
    component: 'AdditionalNotesComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/taxreturns/customise-headings',
    component: 'CustomiseHeadingComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/taxreturns/revised-accounts',
    component: 'RevisedAccountsComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/taxreturns/cic34-report',
    component: 'Cic34ReportComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/taxreturns/cic-34-report',
    component: 'Cic34ReportComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/taxreturns/llp-info',
    component: 'LlpInfoComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/taxreturns/settings-reportformat',
    component: 'ClientReportFormatComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/taxreturns/reports-cicreports',
    component: 'CicReportsComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/taxreturns/tasks-cicsubmission',
    component: 'CicSubmissionWizardComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/taxreturns/tasks-accountingperiods',
    component: 'TaxreturnSettingsComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/taxreturns/reports-accounts',
    component: 'TaxreturnReportsComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/taxreturns/reports-managementaccounts',
    component: 'TaxreturnManagementaccountsComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/taxreturns/reports-cashflows',
    component: 'TaxreturnCashflowsComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/taxreturns/addnewreport',
    component: 'TaxreturnAddnewreportComponent',
    matrix: [],
    query: ['type', 'id'],
  },
  {
    url: '/home/taxreturns/submitlist',
    component: 'TaxreturnTaskSubmitListComponent',
    matrix: [],
    query: ['id'],
  },
  {
    url: '/home/taxreturns/reports-trialbalance',
    component: 'TaxreturnReporttrialbalanceComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/taxreturns/reports-ladger',
    component: 'TaxreturnReportNominalladgerComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/taxreturns/integrations-companyofficers',
    component: 'TaxreturnIntegrationsComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/taxreturns/integrations-persons',
    component: 'TaxreturnIntegrationsPersonlistComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/taxreturns/integrations-history',
    component: 'TaxreturnIntegrationsHistoryComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/taxreturns/emaillogs',
    component: 'TaxreturnLogsEmaillogsComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/taxreturns/tasks-importexceptions',
    component: 'TaxreturnImportexceptionsComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/taxreturns/tasks-nominalmapping',
    component: 'TaxreturnNominalmappingComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/taxreturns/tasks-adjustedtrialbalance',
    component: 'TaxreturnAdjustedtrialbalanceComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/taxreturns/tasks-journals',
    component: 'TaxreturnJournalsComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/taxreturns/working-papers',
    component: 'TaxreturnWorkingpapersComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/taxreturns/statutory-database',
    component: 'TaxreturnStatutorydatabaseComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/taxreturns/accounts-builder',
    component: 'TaxreturnAccountsbuilderComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/taxreturns/validation-centre',
    component: 'TaxreturnValidationcentreComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/taxreturns/tasks-approval',
    component: 'TaxreturnApprovalComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/taxreturns/tasks-reviewpoints',
    component: 'TaxreturnReviewpointsComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/taxreturns/revisions-lineage',
    component: 'TaxreturnRevisionsComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/taxreturns/ixbrl-facts',
    component: 'TaxreturnIxbrlComponent',
    matrix: [],
    query: ['periodId'],
  },
  {
    url: '/home/taxreturns/ixbrl-exceptions',
    component: 'TaxreturnIxbrlComponent',
    matrix: [],
    query: ['periodId'],
  },
  {
    url: '/home/taxreturns/filing-status',
    component: 'TaxreturnFilingStatusComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/taxreturns/tax-handoff',
    component: 'TaxreturnTaxHandoffComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/taxreturns/tasks-profitallocation',
    component: 'TaxreturnProfitAllocationComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/taxreturns/tasks-partneraccounts',
    component: 'TaxreturnPartnerAccountsComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/taxreturns/tasks-groupstructure',
    component: 'TaxreturnGroupStructureComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/taxreturns/tasks-grouptrialbalance',
    component: 'TaxreturnGroupTrialbalanceComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/taxreturns/tasks-groupjournals',
    component: 'TaxreturnGroupJournalsComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/taxreturns/regulatory-pack-upgrade',
    component: 'RegulatoryPackUpgradeComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/taxreturns/fixed-asset-sync',
    component: 'FixedAssetSyncComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/taxreturns/reports-managementperiods',
    component: 'TaxreturnManagementPeriodsComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/taxreturns/reports-periodictrialbalance',
    component: 'TaxreturnPeriodicTrialbalanceComponent',
    matrix: [],
    query: ['id'],
  },
  {
    url: '/home/taxreturns/reports-budgets',
    component: 'TaxreturnBudgetsComponent',
    matrix: [],
    query: ['id'],
  },
  {
    url: '/home/taxreturns/reports-dimensions',
    component: 'TaxreturnDimensionsComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/taxreturns/reports-managementpacks',
    component: 'TaxreturnManagementPacksComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/taxreturns/userlogs',
    component: 'TaxreturnLogsUserlogsComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/ticket',
    component: 'SupportTicketComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/home/authorisation-codes',
    component: 'AuthorisationCodesComponent',
    matrix: [],
    query: [],
  },
  {
    url: '/login',
    component: 'LoginComponent',
    matrix: [],
    query: ['reason', 'returnUrl'],
  },
];

export const manifestRedirects: readonly { from: string; to: string }[] = [
  {
    from: '/home/manage',
    to: '/home/manage/clients',
  },
  {
    from: '/home/settings',
    to: '/home/settings/authorisation-codes',
  },
  {
    from: '/home/taxreturns',
    to: '/home/taxreturns/tasks-accountingperiods',
  },
  {
    from: '/home/taxreturns/setting-notes',
    to: '/home/taxreturns/accounting-policy',
  },
];

export const manifestLayouts: readonly { url: string; component: string }[] = [
  {
    url: '/home',
    component: 'HomeComponent',
  },
  {
    url: '/home/manage',
    component: 'ManageComponent',
  },
  {
    url: '/home/settings',
    component: 'SettingsComponent',
  },
  {
    url: '/home/taxreturns',
    component: 'TaxreturnComponent',
  },
];
